export const setLocalData = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalData = (key) => {
  const itemStr = localStorage.getItem(key);
  return itemStr ? JSON.parse(itemStr) : null;
};
